export const useApi: typeof useFetch = (url, opts?) => {
  const config = useRuntimeConfig()

  return useFetch(url, {
    baseURL: config.public.baseURL,
    credentials: 'include',

    onRequest({ options }) {
      options.headers = setupHeaders(options.headers)
    },

    onResponseError({ response }) {
      if ([404, 500].includes(response.status)) {
        showError({
          // @ts-expect-error "Extected error"
          message: response?._data?.detail ?? 'Error desconocido',
          statusCode: response.status,
        })
        return
      }
    },

    ...opts,
  })
}
